<template>
  <div class="article col px-0 contact d-flex flex-column">
    <div class="content-title">
      <div class="media">
        <div class="media-body">
          <h1>
            {{ $t(`feature.report.title`) }}
          </h1>
          <breadcrumbs :labels="breadcrumbsLabels"></breadcrumbs>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Breadcrumbs from "./Breadcrumbs";

export default {
  components: {
    Breadcrumbs
  },
  data() {
    return {
      breadcrumbsLabels: []
    };
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/layout/ReportLayout.vue